import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import { getWinningItemsCount, getOutbidItemsCount } from '../bid'
import { getUserId } from '../session/'
import { isCurrentBidsOpen } from './selectors'
import { toggleCurrentBids } from './actions'
import {
  getPendingCheckoutCount,
  getPendingCheckoutIds,
  getPendingCheckoutError
} from '../checkout/index'
import { withRouter } from 'react-router-dom'

const mapStateToProps = state => ({
  winningItemsCount: getWinningItemsCount(state),
  outbidItemsCount: getOutbidItemsCount(state),
  pendingCheckoutCount: getPendingCheckoutCount(state),
  pendingCheckoutIds: getPendingCheckoutIds(state),
  pendingCheckoutError: getPendingCheckoutError(state),
  isUserLoggedIn: Boolean(getUserId(state)),
  isCurrentBidsOpen: Boolean(isCurrentBidsOpen(state))
})

const mapDispatch = {
  toggleCurrentBids
}

const withHeaderData = connect(mapStateToProps, mapDispatch)

export const withButtonHandlers = withHandlers({
  onNotificationButtonClick: props => e => {
    e && e.preventDefault()
    props.toggleCurrentBids()
    window && window.scrollTo(0, 0)
  },
  onShoppingButtonClick: props => e => {
    e && e.preventDefault()
    if (props.pendingCheckoutCount === 1 && !props.pendingCheckoutError) {
      const checkoutId = props.pendingCheckoutIds[0]
      //go to checkout
      props.history.push(`/checkout/${checkoutId}`)
    } else if (props.pendingCheckoutCount > 1 || props.pendingCheckoutError) {
      //go to user profile/checkouts when there's more than 1
      props.history.push('/myprofile/myorders')
    }
  }
})

const decorator = compose(withRouter, withHeaderData, withButtonHandlers)

export default decorator



// WEBPACK FOOTER //
// ./src/services/layout/header-context.js